import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { FieldModel } from '../../../../../models/form/field';
import { FieldType } from '../../../../../models/form/fieldType';
import TextProperties from './fields/TextProperties';
import LongTextProperties from './fields/LongTextProperties';
import StaticTextProperties from './fields/StaticTextProperties';
import DateProperties from './fields/DateProperties';
import NumericProperties from './fields/NumericProperties';
import EmailProperties from './fields/EmailProperties';
import DateTimeProperties from './fields/DateTimeProperties';
import TimeProperties from './fields/TimeProperties';
import BirthdateProperties from './fields/BirthdateProperties';
import AcknowledgmentProperties from './fields/AcknowledgmentProperties';
import CheckBoxProperties from './fields/CheckBoxProperties';
import ToggleProperties from './fields/ToggleProperties';
import YesNoProperties from './fields/YesNoProperties';
import SelectProperties from './fields/SelectProperties';
import OptionListProperties from './fields/OptionListProperties';
import RatingProperties from './fields/RatingProperties';
import SignatureProperties from './fields/SignatureProperties';
import EmbeddedPhotoProperties from './fields/EmbeddedPhotoProperties';
import VideoProperties from './fields/VideoProperties';
import DocumentViewerProperties from './fields/DocumentViewerProperties';
import WeblinkProperties from './fields/WeblinkProperties';
import HtmlProperties from './fields/HtmlProperties';
import PaymentOptionListProperties from './fields/PaymentOptionListProperties';
import PaymentChoiceListProperties from './fields/PaymentChoiceListProperties';
import { selectedFieldSelector } from '../../../../../slices/formadmin';
import UploadFileProperties from './fields/UploadFileProperties';
import ProductsProperties from './fields/ProductsProperties';

const FieldProperties: FC = () => {
  const field = useSelector(selectedFieldSelector) as FieldModel;

  if (!field) {
    return null;
  }

  switch (field.type) {
    case FieldType.Text:
      return <TextProperties />;
    case FieldType.LongText:
      return <LongTextProperties />;
    case FieldType.StaticText:
      return <StaticTextProperties />;
    case FieldType.Numeric:
      return <NumericProperties />;
    case FieldType.EmailAddress:
      return <EmailProperties />;
    case FieldType.Date:
      return <DateProperties />;
    case FieldType.Datetime:
      return <DateTimeProperties />;
    case FieldType.Time:
      return <TimeProperties />;
    case FieldType.Birthdate:
      return <BirthdateProperties />;
    case FieldType.Acknowledgment:
      return <AcknowledgmentProperties />;
    case FieldType.CheckBox:
      return <CheckBoxProperties />;
    case FieldType.Toggle:
      return <ToggleProperties />;
    case FieldType.YesNo:
      return <YesNoProperties />;
    case FieldType.Select:
      return <SelectProperties />;
    case FieldType.OptionList:
      return <OptionListProperties />;
    case FieldType.EmbeddedPhoto:
      return <EmbeddedPhotoProperties />;
    case FieldType.Video:
      return <VideoProperties />;
    case FieldType.DocumentViewer:
      return <DocumentViewerProperties />;
    case FieldType.WebLink:
      return <WeblinkProperties />;
    case FieldType.HTML:
      return <HtmlProperties />;
    case FieldType.Rating:
      return <RatingProperties />;
    case FieldType.Signature:
      return <SignatureProperties />;
    case FieldType.PaymentOptionList:
      return <PaymentOptionListProperties />;
    case FieldType.PaymentChoiceList:
      return <PaymentChoiceListProperties />;
    case FieldType.UploadFile:
      return <UploadFileProperties />;
    case FieldType.Products:
      return <ProductsProperties />;
  }
};

export default FieldProperties;
